import type {
  DashboardProductListItem,
  DashboardProductListResponse,
} from '@pos/types';

import { dashboardApi } from '../lib/apiClient';

const PROMOTION_PRODUCT_PAGE_SIZE = 20;
const PRODUCT_HYDRATION_CHUNK_SIZE = 200;

export function searchPromotionProducts(
  search: string,
  page: number,
): Promise<DashboardProductListResponse> {
  return dashboardApi.listProductsPage({
    search: search.trim(),
    status: 'active',
    limit: PROMOTION_PRODUCT_PAGE_SIZE,
    offset: (page - 1) * PROMOTION_PRODUCT_PAGE_SIZE,
  });
}

export async function getPromotionProductsByIds(
  ids: string[],
): Promise<DashboardProductListItem[]> {
  const uniqueIds = [...new Set(ids)];
  if (uniqueIds.length === 0) return [];

  const chunks: string[][] = [];
  for (
    let index = 0;
    index < uniqueIds.length;
    index += PRODUCT_HYDRATION_CHUNK_SIZE
  ) {
    chunks.push(uniqueIds.slice(index, index + PRODUCT_HYDRATION_CHUNK_SIZE));
  }
  const pages = await Promise.all(
    chunks.map((chunk) =>
      dashboardApi.listProductsPage({
        ids: chunk,
        status: 'all',
        limit: PRODUCT_HYDRATION_CHUNK_SIZE,
        offset: 0,
      }),
    ),
  );
  return pages.flatMap((page) => page.items);
}
